import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FieldDesignerService {


  url = environment.serverAPI9 + "/api";


  constructor(private http: HttpClient) { }

  saveFieldDesigner(plans: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}/titleTexts`, plans)
  }

  getAllFieldDesigners(Page: number, size: number, sort): Observable<Object> {
    return this.http.get(`${this.url}/titleTexts?page=${Page}&size=${size}&sort=${sort}`);
  }

  getFieldDesignerById(id: number): Observable<Object> {
    return this.http.get(`${this.url}/titleTexts/${id}`);
  }

  FieldDesignerSearch(query: any, Page: any, size: any, sort: any): Observable<Object> {

    return this.http.get(`${this.url}/titleTexts/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }

  deleteByTitleId(titleId: any): Observable<Object> {
    return this.http.delete(`${this.url}/titleTexts/${titleId}`);
  }

  getAllContactFields(Page: number, size: number, sort): Observable<Object> {
    return this.http.get(`${this.url}/contactFieldGroups?page=${Page}&size=${size}&sort=${sort}`);
  }

  saveContactFields(plans: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}/contactFieldGroups`, plans)
  }

  deleteByContactFieldGroupId(groupId: any): Observable<Object> {
    return this.http.delete(`${this.url}/contactFieldGroups/${groupId}`);
  }

  getContactFieldsById(fieldId: number): Observable<Object> {
    return this.http.get(`${this.url}/contactFieldGroups/${fieldId}`);
  }

  getContactFieldsByIdAndUserId(fieldId: number): Observable<Object> {
    return this.http.get(`${this.url}/contactFieldGroups/user/${fieldId}`);
  }

  getAllContactFieldsDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/contactFieldGroups/dropdown`);
  }

  getMyViewByUserId(): Observable<Object> {
    return this.http.get(`${this.url}/contactFieldGroups/users/userId`);
  }

}
